import { createSlice } from "@reduxjs/toolkit";
import services from "../../api/services";
import PropertyService from "@api/services/PropertyService";
import { getAssingModules } from "@api/services/newServices";
export const initialState = {
  allProperty: [],
  bookingLogs: [],
  showProperties: [],
  assignedModules: [],
  foodPaymentHistory: [],
  kotOrders: [],
  kotLogs: []
};

const propertyData = createSlice({
  name: "propertyData",
  initialState,
  reducers: {
    getallProperty: (state, { payload }) => {
      state.allProperty = payload;
    },
    getShowProperty: (state, { payload }) => {
      state.showProperties = payload;
    },
    getAllLogById: (state, { payload }) => {
      state.bookingLogs = payload;
    },
    setAssignedModules: (state, { payload }) => {
      state.assignedModules = payload;
    },
    setKotOrders: (state, {payload})=>{
      state.kotOrders = payload
    },
    setAllKot: (state, { payload }) => {
      state.kotLogs = payload;
    },
  },
});

export const {
  getallProperty,
  getAllLogById,
  getShowProperty,
  setAssignedModules,
  setKotOrders,
  setAllKot
} = propertyData.actions;

// Action creators are generated for each case reducer function
export const propertyAllData = (state) => state?.AllData;

export default propertyData.reducer;

export const getProperties = (userInfo) => {
  return async (dispatch) => {
    try {
      const authRes = await services.auth.mainPropertyLoginService(userInfo);
      if (authRes.status == 200) {
        await dispatch(getallProperty(authRes.data.data.userProperty));
        return {
          userId: authRes.data?.data?.id,
          isOwner: true,
          ownerWithacceptAgreemnet: authRes.data?.data?.agreement,
          role: authRes.data?.data?.role,
          propertiesCount: authRes.data.data.userProperty.length,
        };
        //   } else {
        //     return false;
        //   }
        // }
      } else {
        return "Pass";
      }
    } catch (error) {
      return "Pass";
    }
  };
};
export const getActivity = (id) => {
  return async (dispatch) => {
    try {
      const res = await services.property.getActivityByBooking(id);
      if (res.status == 200) {
        dispatch(getAllLogById(res.data.data));
      }
    } catch (error) {}
  };
};
export const createLogs = (params) => {
  return async (dispatch) => {
    try {
      const res = await services.property.createActivity(params);
      if (res.status == 200) {
        dispatch(getActivity(params?.bookingId));
      }
    } catch (error) {}
  };
};
export const getKotActivity = (id) => {
  return async (dispatch) => {
    try {
      const res = await services.property.getKotActivity(id);
      if (res.status == 200) {
        dispatch(setAllKot(res.data.data));
      }
    } catch (error) {}
  };
};
export const createKotLogs = (params) => {
  return async (dispatch) => {
    try {
      const res = await services.property.createKotActivity(params);
      if (res.status == 200) {
        dispatch(getKotActivity(params?.bookingId));
      }
    } catch (error) {}
  };
};
export const getPropertiesAll = () => {
  return async (dispatch) => {
    try {
      const res = await PropertyService.getRroomsPropertyService();
      if (res.status === 200) {
        const itemsArr = [];
        res?.data.data?.map((item) => {
          let obj = {
            value: item.id,
            label: item.name + ": #" + item.propertyCode,
            ...item,
          };
          itemsArr.push(obj);
        });
        dispatch(getShowProperty(itemsArr));
        return true;
      }
    } catch (error) {}
  };
};
export const getConfigModule = (userDetail) => {
  return async (dispatch) => {
    if (userDetail?.logintype === "rroomUser" || userDetail?.role < 4) {
      return;
    }
    try {
      const res = await getAssingModules({
        id: userDetail.id,
        property: userDetail.propertyId,
      });
      if (res) {
        dispatch(setAssignedModules(res));
      }
    } catch (error) {}
  };
};
